// extracted by mini-css-extract-plugin
export var quantityInput = "_nq-0";